import { useStaticQuery, graphql } from 'gatsby'

// :::: GET Article from Article title ::::
export const getStrapiSeoData = type => {
  const { allStrapiSeo } = useStaticQuery(allStrapistaticSeo)

  const list = allStrapiSeo?.nodes?.[0]?.Seo || []
  const item = list.find(node => node.strapi_component === type)
  return item || null
}

const allStrapistaticSeo = graphql`
  query {
    allStrapiSeo {
      nodes {
        Seo {
          ... on STRAPI__COMPONENT_SHARED_BLOGS {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_CUSTODIANS_SERIES_PAGE {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_EVENTS {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_HERITAGE_SERIES {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_HOME_PAGE {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_PARTNERS {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_BOARD_MEMBERS {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_POPE_FRANCIS_PAGE {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_SYMPOSIUM_SERIES {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_VIDEOS {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_OTHER_RESOURCES {
            id
            strapi_component
          }
          ... on STRAPI__COMPONENT_SHARED_ABOUT {
            id
            strapi_component
          }
        }
      }
    }
  }
`
